import {
  AttachMoney,
  Build,
  Assessment,
  SmsRounded,
  List,
  Quiz,
  Handyman,
  AssistantPhotoRounded,
  RequestQuote,
  Tune,
  Category,
} from '@mui/icons-material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export default [
  {
    name: 'Statistique',
    link: '/statistiques/',
    icon: Assessment,
  },
  {
    name: 'Combos',
    icon: Handyman,
    childs: [
      {
        name: 'Produits',
        icon: Build,
        link: '/config/table/products',
      },
      {
        name: 'Combos',
        icon: Build,
        link: '/config/table/combos',
      },
      {
        name: 'Combos devis',
        icon: Build,
        link: '/config/combinations',
      },
      {
        name: 'Combos métiers',
        icon: Build,
        link: '/config/configMetiersSteps',
      },
      {
        name: 'Combos métiers devis',
        icon: Build,
        link: '/config/configMetiersDevis',
      },
      {
        name: 'Sous-métiers',
        icon: Build,
        link: '/config/configSousMetiers',
      },
      {
        name: 'Natures d\'intervention',
        icon: Category,
        link: '/config/table/naturesIntervention',
      },
      {
        name: 'Questions / Réponses',
        icon: Quiz,
        link: '/config/table/questions',
      },
      {
        name: 'Suggestions Réponses',
        icon: AssistantPhotoRounded,
        link: '/config/table/suggestionsReponse',
      },
    ],
  },
  {
    name: 'Config',
    icon: Build,
    link: '/config/general',
  },
  {
    name: 'Import Fournisseurs',
    icon: Build,
    link: '/config/fournisseursCSV',
  },
  {
    name: 'Gestion fournisseurs',
    icon: Build,
    link: '/config/fournisseursManager',
  },
  {
    name: 'Grand Comptes',
    icon: Build,
    childs: [
      {
        name: 'Liste',
        icon: List,
        link: '/config/table/grandcompte',
      },
      {
        name: 'Gestion',
        icon: List,
        link: '/config/grandCompte',
      },
      {
        name: 'Liste d\'interventions',
        icon: List,
        link: () => '/intervention/btob/btob',
      },
      {
        name: 'Produits GC',
        icon: Build,
        link: '/config/table/gcProducts',
      },
    ],
  },
  {
    name: 'Signalements',
    icon: Build,
    link: '/config/table/signalements',
  },
  {
    name: 'Raisons Archive SST',
    icon: Build,
    link: '/config/table/raisonsArchiveSST',
  },
  {
    name: 'Utilisateurs',
    icon: Build,
    link: '/config/users',
  },
  {
    name: 'Suggestions',
    icon: Build,
    link: '/config/table/suggestions',
  },
  {
    name: 'Annulations',
    icon: Build,
    link: '/config/table/annulations',
  },
  {
    name: 'Commissions',
    icon: AttachMoney,
    link: '/config/commissions',
  },
  {
    name: 'Remuneration variable',
    icon: RequestQuote,
    childs: [
      {
        name: 'Constantes',
        icon: RequestQuote,
        link: '/commissions/constantes',
      },
      {
        name: 'Parametrage mensuel',
        icon: Tune,
        link: '/commissions/config',
      },
      {
        name: 'Commissions mensuelles',
        icon: RequestQuote,
        link: '/commissions/mensuelles',
      },
    ],
  },
  {
    name: 'Gestion d\'Ip',
    icon: Build,
    link: '/config/ip',
  },
  {
    name: 'Raisons appels',
    icon: Build,
    link: '/config/callNotTransform',
  },
  {
    name: 'Suggestions SMS & MAIL',
    icon: Build,
    link: '/config/table/suggestionsSMS',
  },
  {
    name: 'Config liens',
    icon: Build,
    link: '/config/table/configLink',
  },
  {
    name: 'Sources blacklistés',
    icon: Build,
    link: '/config/blackListSource',
  },
  {
    name: 'SMS',
    icon: SmsRounded,
    childs: [
      {
        name: 'Dashbord',
        icon: SmsRounded,
        link: '/config/sms',
      },
      {
        name: 'Mms reçus',
        icon: SmsRounded,
        link: '/mms',
      },
    ],
  },
  {
    name: 'Instructions ChatGPT',
    icon: SmartToyIcon,
    link: '/prompt',
  },
];
